import React from "react";
import EmptyStateView from "./EmptyStateView";
import { useMatter } from "../contexts/MatterContext";
import { Button } from "../design/button";

interface Props {}

const NoMatterView: React.FC<Props> = ({}) => {
  const { matters } = useMatter();

  if (matters.length === 0) {
    return (
      <EmptyStateView
        title="No matters found"
        message="Please create a new matter to get started."
        action={<Button href="/onboarding/matter">Create Matter</Button>}
      />
    );
  }
  return (
    <EmptyStateView
      title="No matter selected"
      message="Please select a matter from the list on the left or create a new one."
    />
  );
};

export default NoMatterView;
